<template>
  <div class="classBook">
    <div class="headName">
      <p>{{ typeName }}</p>
    </div>
    <div class="bookList" @scroll.passive="onScroll" ref="boxH">
      <ul ref="scrollH">
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="
            type == 'wailian'
              ? goEwm(item.bookId)
              : type == 'history'
              ? goAudio(item.bookId)
              : goBookInfo(item.bookId)
          "
        >
          <img :src="item.cover" alt />
          <div>
            <div>
              <p class="bookName">{{ item.bookName }}</p>
              <p class="bookDescribe">{{ item.summary | valLength(44) }}</p>
            </div>
            <div>
              <div>
                <p class="authorName">{{ item.authorName | valLength(8) }}</p>
                <p>{{ item.readSum | playNum }}</p>
              </div>
              <div>
                <img
                  src="../assets/imgs/search/historySearchDel.png"
                  alt=""
                  v-if="isShowDel"
                  @click.stop="
                    delBook(isCollect ? item.collectId : item.historyId)
                  "
                />
              </div>
            </div>
          </div>
        </li>
      </ul>
      <ul v-if="!list.length">
        <li
          style="
            text-align: center;
            color: #999;
            font-size: 14px;
            display: block;
            padding: 30px 0;
          "
        >
          ——————&nbsp;空空如也&nbsp;——————
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
let Base64 = require("js-base64").Base64;
import setTitleHack from "../assets/js/setTitle";
// Base64.decode()
export default {
  data() {
    return {
      typeName: "",
      list: [],
      pageNum: 1,
      pages: 0,
      scrollH: 0,
      boxH_scrollTop: 0,
      isMoreList: true,
      isShowDel: false,
      isCollect: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    let that = this;
    if (from.name == "bookInfo" || from.name == "audio") {
      to.meta.isBack = true;
    }
    next();
  },
  created() {
    var that = this;

    that.type = that.$route.query.type;
    that.typeName = that.$route.query.name;

    if (that.type == "wailian") {
      that.wailianBookList();
    } else if (that.type == "slide") {
      that.getBookSeries();
    } else if (that.type == "hotlis") {
      that.getHotlis();
    } else if (that.type == "newest") {
      that.getNewsList();
    } else if (that.type == "class") {
      that.getClassBooKList();
    } else if (that.type == "collect") {
      that.isShowDel = true;
      that.getCollectList();
    } else if (that.type == "history") {
      that.isShowDel = true;
      that.isCollect = false;
      that.getHistoryList();
    }
  },
  activated() {
    let that = this;
    if (!that.$route.meta.isBack) {
      that.pageNum = 1;
      that.type = that.$route.query.type;
      that.typeName = that.$route.query.name;

      if (that.type == "wailian") {
        that.wailianBookList();
      } else if (that.type == "slide") {
        that.getBookSeries();
      } else if (that.type == "hotlis") {
        that.getHotlis();
      } else if (that.type == "newest") {
        that.getNewsList();
      } else if (that.type == "class") {
        that.getClassBooKList();
      } else if (that.type == "collect") {
        that.isShowDel = true;
        that.getCollectList();
      } else if (that.type == "history") {
        that.isShowDel = true;
        that.isCollect = false;
        that.getHistoryList();
      }
    } else {
      that.$route.meta.isBack = false;
      that.$refs.boxH.scrollTop = that.boxH_scrollTop;
    }
  },
  mounted() {
    let that = this;
    that.$store.commit("setToAudioPage", "");
  },
  methods: {
    wailianBookList() {
      // 外链书籍列表
      var that = this;
      var data = {
        page: {
          pageNum: that.pageNum,
          pageSize: 20,
        },
        deptId: that.$route.query.deptId,
        carouselId: that.$route.query.slideId,
      };
      that.allApi.wailianBookList(data).then((resource) => {
        // console.log(resource.data.data)
        if (that.pageNum == 1) {
          setTitleHack(resource.data.data.paras.deptName);
          that.pages = resource.data.data.totalPage;
          that.list = resource.data.data.list;
        } else {
          that.list = that.list.concat(resource.data.data.list);
        }
        that.$nextTick(() => {
          that.scrollH = that.$refs.scrollH.offsetHeight;
          that.isMoreList = true;
        });
      });
    },
    getBookSeries() {
      // 轮播图 系列书籍列表
      var that = this;
      var data = {
        page: {
          pageNum: that.pageNum,
          pageSize: 20,
        },
        ticket: localStorage.getItem("ticket"),
        carouselId: that.$route.query.slideId,
      };
      that.allApi.getBookSeries(data).then((resource) => {
        // console.log(resource.data.data)
        if (that.pageNum == 1) {
          that.pages = resource.data.data.totalPage;
          that.list = resource.data.data.list;
        } else {
          that.list = that.list.concat(resource.data.data.list);
        }
        that.$nextTick(() => {
          that.scrollH = that.$refs.scrollH.offsetHeight;
          that.isMoreList = true;
        });
      });
    },
    getHotlis() {
      // 重磅热听列表
      var that = this;
      var data = {
        page: {
          pageNum: that.pageNum,
          pageSize: 20,
        },
        ticket: localStorage.getItem("ticket"),
      };
      that.allApi.hotListening(data).then((resource) => {
        // console.log(JSON.parse(resource.data));
        if (that.pageNum == 1) {
          that.pages = resource.data.data.totalPage;
          that.list = resource.data.data.list;
        } else {
          that.list = that.list.concat(resource.data.data.list);
        }
        that.$nextTick(() => {
          that.isMoreList = true;
          that.scrollH = that.$refs.scrollH.offsetHeight;
        });
      });
    },
    getNewsList() {
      // 最新上架列表
      var that = this;
      var data = {
        page: {
          pageNum: that.pageNum,
          pageSize: 20,
        },
        ticket: localStorage.getItem("ticket"),
      };
      that.allApi.newArrival(data).then((resource) => {
        // console.log(JSON.parse(resource.data));
        if (that.pageNum == 1) {
          that.pages = resource.data.data.totalPage;
          console.log(that.pages);
          that.list = resource.data.data.list;
        } else {
          that.list = that.list.concat(resource.data.data.list);
        }
        that.$nextTick(() => {
          that.isMoreList = true;
          that.scrollH = that.$refs.scrollH.offsetHeight;
        });
      });
    },
    getHistoryList() {
      // 历史记录列表
      var that = this;
      var data = {
        page: {
          pageNum: that.pageNum,
          pageSize: 20,
        },
        ticket: localStorage.getItem("ticket"),
      };
      that.allApi.userBookHistory(data).then((resource) => {
        // console.log(resource.data);
        if (that.pageNum == 1) {
          that.list = resource.data.data.list;
          that.pages = resource.data.data.totalPage;
        } else {
          that.list = that.list.concat(resource.data.data.list);
        }
        that.$nextTick(() => {
          that.isMoreList = true;
          that.scrollH = that.$refs.scrollH.offsetHeight;
        });
      });
    },
    getCollectList() {
      // 收藏列表
      var that = this;
      var data = {
        page: {
          pageNum: that.pageNum,
          pageSize: 20,
        },
        ticket: localStorage.getItem("ticket"),
      };
      that.allApi.userBookCollect(data).then((resource) => {
        // console.log(resource.data)
        if (that.pageNum == 1) {
          that.list = resource.data.data.list;
          that.pages = resource.data.data.totalPage;
        } else {
          that.list = that.list.concat(resource.data.data.list);
        }
        that.$nextTick(() => {
          that.isMoreList = true;
          that.scrollH = that.$refs.scrollH.offsetHeight;
        });
      });
    },
    getClassBooKList() {
      // 根据id获取分类id
      var that = this;
      var data = {
        page: {
          pageNum: that.pageNum,
          pageSize: 20,
        },
        ticket: localStorage.getItem("ticket"),
        classTypeId: that.$route.query.classTypeId,
      };
      that.allApi.getBookListByType(data).then((resource) => {
        // console.log(resource.data.data)
        if (that.pageNum == 1) {
          that.pages = resource.data.data.totalPage;
          that.list = resource.data.data.list;
        } else {
          that.list = that.list.concat(resource.data.data.list);
        }
        that.$nextTick(() => {
          that.scrollH = that.$refs.scrollH.offsetHeight;
          that.isMoreList = true;
        });
      });
    },
    onScroll() {
      var that = this;
      var boxH = that.$refs.boxH.offsetHeight;
      var boxTop = that.$refs.boxH.scrollTop;
      that.boxH_scrollTop = boxTop;
      if (that.isMoreList && that.scrollH - boxH - boxTop < 30) {
        if (that.pageNum + 1 > that.pages) {
          that.pageNum = that.pages;
          return false;
        } else {
          that.isMoreList = false;
          that.pageNum++;
          if (that.type == "wailian") {
            that.wailianBookList();
          } else if (that.type == "slide") {
            that.getBookSeries();
          } else if (that.type == "hotlis") {
            that.getHotlis();
          } else if (that.type == "newest") {
            that.getNewsList();
          } else if (that.type == "collect") {
            that.getCollectList();
          } else if (that.type == "history") {
            that.getHistoryList();
          } else if (that.type == "class") {
            that.getClassBooKList();
          }
        }
      }
    },
    delHistory(hisId) {
      var that = this;
      var data = {
        ids: hisId.join(","),
      };
      that.allApi.delUserBookHistory(data).then((resource) => {
        // console.log(resource.data)
        console.log("已删除该条历史记录");
        that.getHistoryList();
      });
    },
    delUserBookCollect(hisId) {
      var that = this;
      var data = {
        ids: hisId.join(","),
      };
      // console.log(data)
      that.allApi.delUserBookCollect(data).then((resource) => {
        console.log("已取消该书收藏记录");
        that.getCollectList();
      });
    },
    delBook(hisId) {
      var that = this;
      that.pageNum = 1;
      if (that.isCollect) {
        that.delUserBookCollect([hisId]);
      } else {
        that.delHistory([hisId]);
      }
    },
    goBookInfo(id) {
      var that = this;
      that.$router.push({ path: `/bookInfo/${id}` });
    },
    goAudio(id) {
      var that = this;
      that.$store.commit("setToAudioPage", "history");
      let audioInfo = {};

      // if( that.$store.state.audioInfo.firstPlay == "y" ) {
      //     audioInfo.firstPlay = "n";
      // }
      if (that.$store.state.audioInfo.isPlay == "n") {
        audioInfo.isPlay = "y";
      }

      that.$store.commit("setAudioInfo", audioInfo);
      that.$router.push({ path: `/audio/${id}` });
    },
    goEwm(bookId) {
      let that = this;

      location.href =
        "http://qrcode-share.yuntuys.com/v2/?" +
        Base64.encode(that.$route.query.deptId) +
        "&" +
        Base64.encode(bookId);
    },
  },
};
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.classBook {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 0;
  top: 0;
  z-index: 2;
  background: #fff;
  overflow: hidden;
  padding-top: rem(24px);
  .headName {
    width: 100%;
    line-height: rem(72px);
    color: #333;
    font-size: rem(36px);
    text-align: center;
    font-weight: bold;
    margin-bottom: rem(45px);
    position: relative;
  }
  .bookList {
    position: absolute;
    left: 0;
    top: rem(117px);
    bottom: 0;
    right: 0;
    padding: 0 rem(50px);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    > ul {
      overflow: hidden;
      > li {
        width: 100%;
        padding-bottom: rem(30px);
        margin-bottom: rem(30px);
        border-bottom: 1px solid #e5e5e5;
        overflow: hidden;
        display: flex;
        > img {
          width: rem(200px);
          height: rem(200px);
          margin-right: rem(40px);
          border-radius: rem(6px);
        }
        > div {
          width: 0%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          > div:first-child {
            .bookName {
              font-size: rem(32px);
              font-weight: bold;
              color: #111;
              line-height: rem(45px);
              margin-bottom: rem(10px);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .bookDescribe {
              font-size: rem(24px);
              color: #999;
              line-height: rem(32px);
            }
          }

          > div:last-child {
            overflow: hidden;
            font-size: rem(24px);
            color: #333;
            line-height: rem(34px);
            > div:first-child {
              float: left;
              overflow: hidden;
              > p {
                float: left;
                position: relative;
                padding-left: rem(30px);
                &:first-child {
                  margin-right: rem(42px);
                  &::before {
                    content: "";
                    background: url("../assets/imgs/index/anchorIcon.png")
                      center / rem(25px) rem(25px) no-repeat;
                    width: rem(25px);
                    height: rem(25px);
                    position: absolute;
                    left: 0;
                    top: rem(4px);
                  }
                }
                &:last-child {
                  &::before {
                    content: "";
                    background: url("../assets/imgs/index/playNumIcon.png")
                      center / rem(25px) rem(25px) no-repeat;
                    width: rem(25px);
                    height: rem(25px);
                    position: absolute;
                    left: 0;
                    top: rem(4px);
                  }
                }
              }
            }
            > div:last-child {
              float: right;
              > img {
                display: block;
                width: rem(30px);
                height: rem(34px);
              }
            }
          }
        }
      }
    }
  }
}
</style>
